<template>
  <div id="sales_price_matched">
    <div class="card">
      <div class="card-content">
        <span class="card-title">
          Sales Price vs Matched Quote
          <el-select
            v-model="selected_branches"
            size="small"
            multiple
            collapse-tags
            style="margin-left: 10px;"
            placeholder="Select branch(es)"
            @change="fill_data"
          >
            <el-option
              v-for="branch in branches_list"
              :key="branch.id"
              :label="branch.name"
              :value="branch.id"
            />
          </el-select>
        </span>

        <el-date-picker
          v-model="selected_date_range"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          style="width: auto !important;"
          :picker-options="pickerOptions2"
          @change="fill_data"
        />
        <br>
        <br>
        <table>
          <tr class="header">
            <th>SALES</th>
            <th>QUOTE</th>
            <th>DIFFERENCE</th>
          </tr>
          <tr class="rows">
            <td>
              <span class="center">{{ total_sales | currency }}</span>
            </td>
            <td>
              <span class="center">{{ total_quotes | currency }}</span>
            </td>
            <td>
              <span class="center">{{ difference | currency }}</span>
            </td>
          </tr>
        </table>

        <pie-chart
          :chart-data="datacollection"
          :options="chartOptions"
        />
      </div>
      <div class="card-action">
        <button
          class="btn btn-small"
          @click="show_details"
        >
          Details
        </button>
      </div>
    </div>
    <modal
      name="sales_list"
      :height="700"
      :width="1200"
      :adaptive="true"
    >
      <div class="card">
        <div class="card-content">
          <span class="card-title">
            {{ list_title }}
            <hr>
          </span>
          <div
            v-show="is_loading"
            class="progress"
          >
            <div class="indeterminate" />
          </div>
          <el-table
            :data="rows"
            style="width: 100%"
            height="600"
            :row-class-name="set_bg_color"
            @row-dblclick="row_click"
          >
            <el-table-column
              v-for="column in columns"
              :key="column"
              :prop="column"
              :label="column | capitalize"
              sortable
            />
          </el-table>
        </div>
        <div class="card-action" />
      </div>
    </modal>
  </div>
</template>
<script>
import PieChart from './PieChart';

export default {
  name: 'SalesPriceMatchedQuote',
  components: {
    PieChart,
  },
  data() {
    return {
      datacollection: null,
      branches_list: [],
      total_sales: 0,
      total_quotes: 0,
      columns: ['Sales', 'Quotes'],
      rows: [],
      list_title: '',
      is_loading: false,
      pickerOptions2: {
        shortcuts: [
          {
            text: 'Current month',
            onClick(picker) {
              const end = new Date();
              const start = new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                1
              );
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last 6 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last year',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      selected_date_range: '',
    };
  },
  computed: {
    current_date() {
      return new Date();
    },
    start_date() {
      return new Date(
        this.current_date.getFullYear(),
        this.current_date.getMonth(),
        1
      );
    },
    end_date() {
      return new Date(
        this.current_date.getFullYear(),
        this.current_date.getMonth(),
        this.current_date.getDate()
      );
    },
    difference() {
      return this.total_sales - this.total_quotes;
    },
  },
  mounted() {
    this.load_branches_list();
    this.selected_date_range = [this.start_date, this.end_date];
    this.fill_data();
  },
  created() {},
  methods: {
    load_branches_list() {
      let self = this;
      self.is_loading = true;
      this.$http.get('/branches_list').then((response) => {
        this.branches_list = response.data;
        this.selected_branches = this.branches_list.map((c) => c.id);
        this.fill_data();
        self.is_loading = false;
      });
    },
    row_click(row, column, event) {
      if (row.id > 0) window.open('/edit_proposal?id=' + row.id, '_blank');
    },
    set_bg_color({ row, rowIndex }) {
      if (row.color === true) {
        return 'success-row';
      }
      return '';
    },
    fill_data() {
      this.$http
        .post('/get_sum_sales_price_matched_quotes', {
          start_date: this.selected_date_range[0],
          end_date: this.selected_date_range[1],
          branches_ids: this.selected_branches
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.total_sales = response.data.data.total_sales;
            this.total_quotes = response.data.data.total_quotes;

            let categorized_sales = response.data.data.categorized_sales;
            let categorized_quotes = response.data.data.categorized_quotes;
            let bg_colors = Array(categorized_sales.total.length)
              .fill('lightgreen')
              .concat(Array(categorized_quotes.total.length).fill('#f38686'));

            this.datacollection = {
              // labels: ['Profit', 'Cost'],
              labels: categorized_sales.categories_names.concat(
                categorized_quotes.categories_names
              ),
              datasets: [
                {
                  label: 'Invoices',
                  backgroundColor: bg_colors,
                  data: categorized_sales.total.concat(
                    categorized_quotes.total
                  ),
                },
              ],
            };
          }
        });
    },
    show_details() {
      this.open_modal();
      this.columns = [];
      this.rows = [];
      this.list_title = 'Details';
      this.is_loading = true;
      this.$http
        .post('/get_sales_price_matched_quotes', {
          start_date: this.selected_date_range[0],
          end_date: this.selected_date_range[1],
          branches_ids: this.selected_branches
        })
        .then((response) => {
          this.is_loading = false;
          if (response.data.status == 200) {
            this.columns = response.data.data.columns;
            this.rows = response.data.data.rows;
          }
        });
    },
    open_modal() {
      this.$modal.show('sales_list');
    },
    hide_modal() {
      this.$modal.hide('sales_list');
    },
    chartOptions: function() {
      return { responsive: true, maintainAspectRatio: false };
    },
  },
};
</script>

<style>
#sales_price_matched th {
  text-align: center;
  padding: 10px;
}

#sales_price_matched th {
  font-weight: 800;
}
#sales_price_matched .header {
  background-color: #ddecf9;
}
#sales_price_matched .subheader {
  background-color: #e5f3ff;
}
#sales_price_matched .rows {
  background-color: aliceblue;
}
#sales_price_matched .el-table .success-row {
  background: #f0f9eb;
}
</style>
